
import { Vue, Component, Ref } from "vue-property-decorator";
import * as THREE from "three";
@Component({
  name: "PQNextEventWebGL",
})
export default class PQNextEventWebGL extends Vue {
  @Ref() canvas: Element;
  rootClass = "p-home-next-event-webgl";

  mounted() {
    this.main();
  }

  main() {
    const canvas = this.canvas;
    const renderer = new THREE.WebGLRenderer({ canvas });
    renderer.autoClearColor = false;

    const camera = new THREE.OrthographicCamera(
      -1, // left
      1, // right
      1, // top
      -1, // bottom
      -1, // near,
      1 // far
    );
    const scene = new THREE.Scene();

    const plane = new THREE.PlaneGeometry(2, 2);

    const fragmentShader = `
uniform vec3      iResolution;           // viewport resolution (in pixels)
uniform float     iTime;                 // shader playback time (in seconds)

#define SCALE 5.

vec3 random_perlin( vec3 p ) {
    p = vec3(
            dot(p,vec3(300.1,311.7,169.5)),
            dot(p,vec3(469.5,13.3,132.7)), 
            dot(p,vec3(417.3,108.5,96.5)) 
            );
    return -1.0 + 2.0*fract(sin(p)*43758.5453123);
}

float noise_perlin (vec3 p) {
    vec3 i = floor(p);
    vec3 s = fract(p);

    float a = dot(random_perlin(i),s);
    float b = dot(random_perlin(i + vec3(1, 0, 0)),s - vec3(1, 0, 0));
    float c = dot(random_perlin(i + vec3(0, 1, 0)),s - vec3(0, 1, 0));
    float d = dot(random_perlin(i + vec3(0, 0, 1)),s - vec3(0, 0, 1));
    float e = dot(random_perlin(i + vec3(1, 1, 0)),s - vec3(1, 1, 0));
    float f = dot(random_perlin(i + vec3(1, 0, 1)),s - vec3(1, 0, 1));
    float g = dot(random_perlin(i + vec3(0, 1, 1)),s - vec3(0, 1, 1));
    float h = dot(random_perlin(i + vec3(1, 1, 1)),s - vec3(1, 1, 1));

    // Smooth Interpolation
    vec3 u = smoothstep(0.,1.,s);

    return mix(mix(mix( a, b, u.x),
                mix( c, e, u.x), u.y),
            mix(mix( d, f, u.x),
                mix( g, h, u.x), u.y), u.z);
}


void mainImage(out vec4 fragColor, in vec2 fragCoord) {
    vec2 uv = fragCoord.xy/iResolution.x;
    float c = noise_perlin(vec3(SCALE*uv, iTime));
    vec3 color= vec3(c,c,c);
    fragColor = vec4( color, 1);
}

void main() {
  mainImage(gl_FragColor, gl_FragCoord.xy);
}
  `;
    const uniforms = {
      iTime: { value: 0 },
      iResolution: { value: new THREE.Vector3() },
    };
    const material = new THREE.ShaderMaterial({
      fragmentShader,
      uniforms,
    });
    scene.add(new THREE.Mesh(plane, material as any));

    function resizeRendererToDisplaySize(renderer) {
      const canvas = renderer.domElement;
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const needResize = canvas.width !== width || canvas.height !== height;
      if (needResize) {
        renderer.setSize(width, height, false);
      }
      return needResize;
    }

    function render(time) {
      time *= 0.0002; // convert to seconds

      resizeRendererToDisplaySize(renderer);

      const canvas = renderer.domElement;
      uniforms.iResolution.value.set(canvas.width, canvas.height, 1);
      uniforms.iTime.value = time;

      renderer.render(scene, camera);

      requestAnimationFrame(render);
    }

    requestAnimationFrame(render);
  }
}
